export const EMAIL_TEMPLATE_REQUEST = "EMAIL_TEMPLATE_REQUEST";
export const EMAIL_TEMPLATE_RECEIVE = "EMAIL_TEMPLATE_RECEIVE";
export const EMAIL_TEMPLATE_FAILURE = "EMAIL_TEMPLATE_FAILURE";
export const RESET_EMAIL_TEMPLATE = "RESET_EMAIL_TEMPLATE";